// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2rMyq","validationTips":"StatementDescriptor_validationTips__-jTa5"};